<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="40"
    height="48.199"
    viewBox="0 0 40 48.199"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rechteck_2"
          data-name="Rechteck 2"
          width="40"
          height="48.199"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        />
      </clipPath>
    </defs>
    <g id="Gruppe_3" data-name="Gruppe 3" transform="translate(-1817.204 -302.401)">
      <g id="Gruppe_2" data-name="Gruppe 2" transform="translate(1817.204 302.401)">
        <g
          id="Gruppe_1"
          data-name="Gruppe 1"
          transform="translate(0 0)"
          clip-path="url(#clip-path)"
        >
          <path
            id="Pfad_1"
            data-name="Pfad 1"
            d="M32.317,46.292a9.97,9.97,0,0,0-1.192.006c-4.655.194-9,.874-13.618.985-4.616-.111-8.962-.792-13.618-.985A9.966,9.966,0,0,0,2.7,46.292a3.041,3.041,0,0,0-.084,6.033c2.692.508,5.884.351,8.634.753.339.05.895.321,1,.668a20.067,20.067,0,0,1-.029,3.6L6.95,70.973a3.065,3.065,0,0,0,4.836,3.052,4.34,4.34,0,0,0,1.252-1.956c1.525-3.366,2.691-6.918,4.192-10.3.266-.468.556,0,.556,0,1.5,3.38,2.667,6.931,4.192,10.3a4.34,4.34,0,0,0,1.252,1.956,3.065,3.065,0,0,0,4.836-3.052L22.8,57.35a20.093,20.093,0,0,1-.029-3.6c.1-.347.656-.618,1-.668,2.75-.4,5.942-.246,8.634-.753a3.041,3.041,0,0,0-.084-6.033"
            transform="translate(2.492 -28.932)"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            id="Pfad_2"
            data-name="Pfad 2"
            d="M45.05.059c8.324-1.006,9.325,11.257,1.616,12.068C38.481,12.989,37.463.976,45.05.059"
            transform="translate(-26.037 2.492)"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

